
import { authApi } from "../../src/Api";
import {PropType} from 'vue';
import AuthModel from '../../src/Model';
import {AuthAppService} from '../../src/AuthAppService';

export default {
    props: {
        service: {
            type: Object as PropType<AuthAppService>,
        },
        modelValue: {
            type: Object as PropType<AuthModel>,
            required: true,
        },
        onNext: {
            type: Function as PropType<(AuthModel) => Promise<void>>,
            required: true,
        }
    },
    emits: ['cancel'],
    data() {
        return {
            firstName: this.modelValue.firstName,
            lastName: this.modelValue.lastName,
            disabled: true,
            inputErrors: null,
            error: null,
            arrayChecked: ['1', '2', '3'],
            loading: false,
        };
    },
    mounted() {
        this.check();
    },
    computed: {
        configuration() {
            return this.service.configuration;
        },
    },
    methods: {
        onCancel() {
            this.$emit('cancel');
        },
        async onConfirm() {
            this.loading = true;
            try {
                if (!this.disabled) {
                    const result = await authApi.confirm(this.modelValue.hash, this.firstName, this.lastName);
                    const response = result.response();
                    if (response?.redirectUrl) {
                        await authApi.goRedirect(response.redirectUrl);
                        return;
                    }
                    if (result.error()) {
                        this.inputErrors = result.error().errors;
                        this.disabled = result.error().disabled;
                        return;
                    }

                    this.modelValue.isConfirmed = response.isConfirmed;
                    await this.onNext(this.modelValue)
                }
            } catch (err) {
                this.error = err.response.data.message;
                this.loading = false;
            }
        },
        check() {
            this.disabled = this.arrayChecked.length < 3 || (!this.firstName || !this.lastName);
        },
    }
};
